import useResource from "./useResource"
import { pluralize } from "web/services/inflector"

export default function useFieldVisibility({
  subjectType,
  subjectId,
  isTopicRecord,
  fieldId,
}) {
  var urlRoot
  if (!!isTopicRecord) {
    urlRoot = "/topics/records"
  } else {
    urlRoot = `/${pluralize(subjectType)}`
  }

  const key = `${urlRoot}/${subjectId}/field_visibilities/${fieldId}`
  const response = useResource({ key })
  const [data] = response

  return data
}
